import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { BaseService } from "@dmms/core/http";
import { IApiResponse, IBaseHttpResponse } from "@models/http/http-options";
import { AdministrationEndpoints } from "../types/administration-endpoints";
import { ISetting, SettingEnum } from "../models/administration";

@Injectable({
  providedIn: "root",
})
export class AdministrationApiService extends BaseService {
  // Settings methods
  getSettingByKey(
    key: SettingEnum | string,
    version = 1,
  ): Observable<IApiResponse<ISetting>> {
    return this.get<IApiResponse<ISetting>>(
      `v${version}/${AdministrationEndpoints.Setting.replace("{key}", key)}`,
    );
  }

  setSetting(
    setting: Partial<ISetting>,
    version = 1,
  ): Observable<IApiResponse<string>> {
    return this.post<IApiResponse<string>>(
      `v${version}/${AdministrationEndpoints.SettingItems}`,
      setting,
    );
  }

  updateSetting(
    setting: Partial<ISetting>,
    version = 1,
  ): Observable<IBaseHttpResponse> {
    return this.put(
      `v${version}/${AdministrationEndpoints.SettingById.replace("{id}", setting.id)}`,
      setting,
    );
  }
}
